import { render, staticRenderFns } from "./m_footer.vue?vue&type=template&id=e9810dfa&scoped=true"
import script from "./m_footer.vue?vue&type=script&lang=js"
export * from "./m_footer.vue?vue&type=script&lang=js"
import style0 from "./m_footer.vue?vue&type=style&index=0&id=e9810dfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9810dfa",
  null
  
)

export default component.exports